import { useEffect, useState } from 'react';
/* eslint-disable camelcase */
import { Helmet } from 'react-helmet-async';
import { Stack, Container, Typography,  Box, Card, Link, Divider, Button, Grid, ButtonGroup, Tabs, Tab, Dialog } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore';
import { styled } from '@mui/material/styles';
import { Map, Marker } from 'react-map-gl';
import Label from '../../../components/label/Label';
import { auth, db } from '../../../firebase'; 
import useGetAlbumById from '../../../hooks/useGetAlbumById';
import SharePost from './SharePost';
import ViewPricing from './ViewPricing';
import UsePagetracker from '../../../hooks/UsePagetracker';
import SendMessage from '../Inbox/SendMessage';
import Iconify from '../../../components/iconify/Iconify';

function VendorPage() {
  
 
  const location_ = useLocation()
  const { name, cover_image, phone, category, location, description, address, id, userId} = location_.state;
  console.log( location_.state)
 
  UsePagetracker(id, userId)

  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0); 
  const StyledProductImg = styled('img')({       
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  });

  const StyledProductCover = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
  });

  const [isFavorite, setIsFavorite] = useState(false);

  useEffect( () => {
    async function getData()
    {
      onSnapshot( doc(db, "app_users", auth.currentUser?.uid, "likes", id), (doc) => {
        if (doc.exists()) {
          setIsFavorite(true)
         
        } else {
          // docSnap.data() will be undefined in this case
          setIsFavorite(false)
         
        }
          });    
    }
getData()
  }, [location_.state])
  
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const addToFavorite =async () =>{
    if(isFavorite)
    {
      await deleteDoc(doc(db, "app_users", auth.currentUser?.uid, "likes", id)) 
    }
    else{
    await setDoc(doc(db, `app_users`, auth.currentUser?.uid, "likes", id),  {item : id});

    }
  }
      
  useEffect(() => {
    // Query Firestore for the current user's like/dislike status for the item
    const userId = auth.currentUser?.uid;
    if (userId) {
      const userQuery = query(collection(db, 'businessRecommendation'), where('postId', '==', id), where('userId', '==', userId));
      const userQueryUnsubscribe = onSnapshot(userQuery, (userSnapshot) => {
        if (!userSnapshot.empty) {
          setIsLiked(userSnapshot.docs[0].data().is_liked);
        }
      });
    }
  
    // Query Firestore for the total number of likes and dislikes for the item
    const itemQuery = query(collection(db, 'businessRecommendation'), where('postId', '==', id));
    const itemQueryUnsubscribe = onSnapshot(itemQuery, (itemSnapshot) => {
      let likeCount = 0;
       itemSnapshot.forEach((doc) => {
        if (doc.data().is_liked) {
          likeCount += 1;
        }  
      });
      setLikeCount(likeCount); 
    });
  
    // Clean up listeners when the component unmounts
    return () => {
      if (itemQueryUnsubscribe) itemQueryUnsubscribe(); 
    };
  }, [id]);


  const helpful = async ()=>{
    const userId = auth.currentUser?.uid;

    // Create a Firestore query to check if the user has already liked/disliked the item
    const q = query(collection(db, 'businessRecommendation'), where('postId', '==', id), where('userId', '==', userId));
  
    try {
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        // User has already liked/disliked the item, update the existing document
        const doc = querySnapshot.docs[0];
        const isLiked = !doc.data().is_liked;
        await updateDoc(doc.ref, { is_liked: true });
        setIsLiked(isLiked);
      } else {
        // User has not yet liked/disliked the item, create a new document
       await addDoc(collection(db, 'businessRecommendation'), {
          postId: id,
          userId,
          is_liked: true,
          count: 1,
        });
        setIsLiked(true);
      }
    } catch (error) {
      console.error('Error handling like click:', error);
    }
  }
  const [openView, setopenView] = useState(false)
  const handleClickOpenView = () => {
    setopenView(true);
   
  };

  const handleCloseView = () => {
    setopenView(false);
 
  };


    const albums = useGetAlbumById(id)
  return (
    <>
      <Helmet>
        <title>View Profile</title>
      </Helmet>

      <Dialog
        open={openView}
        onClose={handleCloseView}
      ><SendMessage handleClose={handleCloseView} data={userId} busId={id} />
      </Dialog>

      <Container>

      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
          <Typography component={"span"}>
        Profile
          </Typography><br/>
          {name}
          </Typography>    
          {isFavorite ? <Button variant='text' color='error' onClick={()=>addToFavorite()}><Iconify icon="eva:heart-fill" /></Button>     
          :
          <Button  variant='text' color='success'  onClick={()=>addToFavorite()}><Iconify icon="eva:heart-fill" /></Button>     
          }
          
        </Stack>
        <Card>
      <Box sx={{ pt: '45%', position: 'relative' }}>
       
          <Label
            variant="filled"
            color={'info'}
            sx={{
              zIndex: 9,
              top: 16,
              right: 16,
              position: 'absolute',
              textTransform: 'uppercase',
            }}
          >
            {category}
          </Label>
    
        <StyledProductCover alt={name} src={cover_image} />
      </Box>

      <Stack spacing={2} justifyContent={"space-between"}  sx={{ p: 3 }}>
      <Divider sx={{my:3}}>Contact/Address</Divider>
          <Typography variant="subtitle2" noWrap>
          {phone}
          </Typography> 
         
            <Typography variant="subtitle2" noWrap>
            {address}
          </Typography>
            <Button variant='contained' color='success' onClick={()=>handleClickOpenView()}>Send Message</Button>

          <Divider sx={{my:3}}>About</Divider>
          <Typography variant="body1"  >
            {description}
          </Typography>
          <Divider sx={{my:3}}>Map</Divider>
          {location &&<Map
      mapboxAccessToken="pk.eyJ1IjoiY2hpc29tbyIsImEiOiJjbG1oZG43MzQxdmo4M3FxcWNyamJuazg1In0.Qzx7VHsNIxxh-knHPliPWw"
      initialViewState={{
        longitude: location.long,
        latitude: location.lat,
        zoom: 14
      }}
       style={{width: "100%", height:400}}
      mapStyle="mapbox://styles/mapbox/streets-v9"
    >
        {location ? <Marker longitude={location.long} anchor='bottom' latitude={location.lat} color="red" /> : <Typography>Map Data not provided</Typography>}
    </Map>}

          <Button color='success' disabled={isLiked}  onClick={()=>helpful()}>I Recommend  ({likeCount}) </Button>
       </Stack>
   
 
       </Card>
   
        </Grid>
        <Grid item xs={12} md={7}>
        <Tabs value={value} onChange={handleChange} sx={{mb:4}}>
        <Tab label="Feedback" />
        <Tab label="Galley" />
        <Tab label="Pricing" />
        </Tabs>

         {value === 0 && <SharePost id={id} userId={userId} />}   
         {value === 1 && <Grid container spacing={3}>
    
    {albums && albums?.map((g, index)=>(
        <Grid item xs={12} md={12} lg={12} key={index}>
        <Stack direction={"row"} spacing={3} justifyContent={"space-between"} alignItems={"center"}>
            <Typography variant="h4">{g.name}
            <br/><Typography component={"span"}>Album</Typography></Typography>
          
        </Stack>
    
      
        <Grid container spacing={1}>
            {g.images.map((h, index)=>(
        <Grid item xs={12} md={6} key={index}>
                <StyledProductImg alt={h} key={index} src={h} />
            </Grid>
            ))}
        </Grid>
        </Grid>
    ))  }
    </Grid>}
    {value === 2 && <ViewPricing id={id} />}
        </Grid>
      </Grid>
     

      
   
   
    
       

      </Container>
    </>
  )
}

export default VendorPage